import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DialogClose } from '@/components/ui/dialog';

interface DialogCloseButtonProps {
	className?: string;
}

export const DialogCloseButton = ({ className }: DialogCloseButtonProps) => (
	<DialogClose asChild>
		<Button
			variant="ghost"
			size="close"
			className={`hover:bg-transparent ${className}`}
			style={{ margin: 0 }}
		>
			<X className="size-4" />
		</Button>
	</DialogClose>
);
